// Course details modal constants
export const SUBSCRIPTION_PLANS_HEADING = "Subscription Plans";
export const CONTINUE_ON_APP_TEXT =
  "To purchase a subscription, please continue on the app.";
